module.exports = __webpack_public_path__ + "img/kefu.130988fe.png";